import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import VicDetailsTableData from "src/assets/vic-details-table-data.json";

@Component({
  selector: "app-vic-details-table",
  templateUrl: "./vic-details-table.component.html",
  styleUrls: ["./vic-details-table.component.scss"]
})
export class VicDetailsTableComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    "caseNumber",
    "dateConfirmed",
    "age",
    "gender",
    "description",
    "sourceLink"
  ];
  dataSource = new MatTableDataSource<VicDetailsTableDataType>(RAW_DATA);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor() {}

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.setButtonStyle();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private setButtonStyle() {
    const cssText = `box-sizing: border-box;
    position: relative;
    user-select: none;
    cursor: pointer;
    outline: none;
    border: none;
    -webkit-tap-highlight-color: transparent;
    display: inline-block;
    white-space: nowrap;
    text-decoration: none;
    vertical-align: baseline;
    text-align: center;
    margin: 0;
    overflow: visible;
    padding: 0;
    min-width: 0;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    line-height: 40px;
    border-radius: 50%;`;

    const buttonClassNames = [
      "mat-paginator-navigation-first",
      "mat-paginator-navigation-previous",
      "mat-paginator-navigation-next",
      "mat-paginator-navigation-last"
    ];

    buttonClassNames.forEach(className => {
      (document.querySelector(
        "." + className
      ) as HTMLElement).style.cssText = cssText;
    });
  }
}

export interface VicDetailsTableDataType {
  caseNumber: string;
  dateConfirmed: string;
  age?: string;
  gender?: string;
  description: string[];
  sourceLink: string[];
}

const RAW_DATA: VicDetailsTableDataType[] = VicDetailsTableData;
